export const DEFAULT_SPOT_RADIUS = 20;
export const DEFAULT_SPOT_DEADBAND = 10;

export const EMPTY_GEOXP_CONFIG = {
  core: {
    label: 'GeoXp Core Config',
    patterns: [],
    options: {},
  },
  audio: {
    sounds: [],
    options: {},
  },
  video: {
    videos: [],
  },
};

export const getMapSpotsFromConfig = (config) =>
  config?.core.patterns.flatMap((pattern) =>
    pattern.spots
      .filter((spot) => !!spot.position)
      .map((spot) => ({
        ...spot,
        position: {
          ...spot.position,
          radius: spot.position.radius ?? config.core.options?.defaultRadius ?? DEFAULT_SPOT_RADIUS,
          deadband: spot.position.deadband ?? config.core.options?.defaultDeadband ?? DEFAULT_SPOT_DEADBAND,
        },
      }))
  ) ?? [];

/**
 * A spot is manual because it has a CODE, not because it lacks a position: since
 * the `custom` activation type exists (no trigger at all), "no position" is no
 * longer a synonym of "manual", and reading it that way shows the manual-code tab
 * in experiences where nothing can be typed. Same criterion `playManually` uses.
 */
export const configHasManualSpots = (config) => {
  if (!config?.core) return false;

  let manualSpot = false;
  const patterns = config.core.patterns ?? [];
  patterns.forEach((p) => {
    if (p.spots.find((s) => !!s.code)) {
      manualSpot = true;
    }
  });
  return manualSpot;
};

export const configHasGeoSpots = (config) => {
  if (!config?.core) return false;

  let geoSpot = false;
  const patterns = config.core.patterns ?? [];
  patterns.forEach((p) => {
    if (p.spots.find((s) => s.position)) {
      geoSpot = true;
    }
  });
  return geoSpot;
};

// Helper arrow function to get an array of IDs from the previous spots
const getPrevIds = (prev) => {
  if (!Array.isArray(prev)) {
    return [];
  }
  return prev.map((spot) => spot.id);
};

// Arrow function to update the previous array
export const addToPrevious = (prev, spot) => {
  const prevIds = getPrevIds(prev);
  if (prevIds.includes(spot.id)) {
    return prev;
  }
  return [...prev, spot];
};

export const removeFromPrevious = (prev, spotId) => prev?.filter((spot) => spot?.id !== spotId);
